import { useState } from 'react';
import ChatWidget from './ChatWidget.tsx';
import './chat.scss';

const ChatLauncher = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {isOpen && <ChatWidget onClose={() => setIsOpen(false)} />}

      {!isOpen && (
        <button
          className="chat-launcher"
          onClick={() => setIsOpen(true)}
          aria-label="Apri AI advisor"
        >
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          </svg>
          <span className="chat-launcher__label">AI advisor</span>
        </button>
      )}
    </>
  );
};

export default ChatLauncher;
